import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import ColorListBox from '../ColorsListFronts';
import SummaryBar from '../SummaryBar';
import { getFrontsByType } from '../../store/actions/products';
import { connect } from 'react-redux';
import { WardrobesConfigsContext } from '../../contexts/WardrobesConfigsContext';
import { ActiveWardrobeContext } from '../../contexts/ActiveWardrobeContext';
import { ToastContainer, toast } from 'react-toastify';
import Loader from '../Loader';
import PopUp from '../popup/PopUp';
import ColorsGroupPopup from '../popup/ColorsGroupPopup';
import { GAContext } from 'contexts/GAContext';

const HingedFrontsConfig = props => {
  const {
    frontColorList,
    activeFront,
    setActiveFrontsPanels,
    setOpenDoorsState,
    frontGroupList,
    setPrice,
  } = props;

  const history = useHistory();

  const [state, setState] = useState({
    panelActive: false,
    panelDefaultLoad: false,
    colorList: [],
  });

  const { wardrobesConfigs, setWardrobesConfigs } = useContext(WardrobesConfigsContext);
  const { activeWardrobe } = useContext(ActiveWardrobeContext);
  const { GA } = useContext(GAContext);

  let wardrobe = { ...wardrobesConfigs[activeWardrobe] };

  let activeFrontTmp;

  if (state.panelActive) {
    if (activeFront !== undefined) {
      const door = activeFront.split('_');
      activeFrontTmp = wardrobesConfigs[activeWardrobe].fronts[door[1]];
    }
  }

  const notify = () => {
    toast.error('Wybierz drzwi w celu doboru koloru', {
      closeOnClick: true,
      position: 'top-right',
      autoClose: 10000,
      toastId: 1, // show only one
    });
  };

  const changeFrontMaterial = (frontObj, activeDoor = false) => {
    let frontInfo = activeFront !== undefined ? activeFront.split('_') : ['Front', '0', '0'];
    let active = activeDoor;
    active = active ? active : parseInt(frontInfo[1]);
    wardrobe.withoutDoor = false;
    wardrobe.fronts[active] = frontObj;
    wardrobe.handles = {
      left: null,
      right: null,
    };

    wardrobesConfigs[activeWardrobe] = wardrobe;
    setWardrobesConfigs(wardrobesConfigs);
    setPrice();
    GA('Front configuration', 'Select fronts of wardrobe');
  };

  useEffect(() => {
    if (activeFront !== undefined) {
      let door = activeFront.split('_');
      if (door[1] !== undefined) {
        setActiveFrontsPanels(['Front_' + door[1] + '_' + door[2]]);
      }
    } else {
      setActiveFrontsPanels([]);
    }
    /* eslint-disable-next-line */
  }, [activeFront]);

  useEffect(() => {
    if (wardrobesConfigs[activeWardrobe]) {
      let activeFrontTmp = activeFront;
      if (!!!activeFront) {
        activeFrontTmp = 'Front_0_0';
      }

      let door = activeFrontTmp.split('_');
      let doorsSizes = wardrobe.doors_sizes;
      let widthDoors = doorsSizes[door[1]];

      let colorList = frontColorList.filter(item => {
        return item.dimensions.x === widthDoors;
      });
      setState({ ...state, colorList: colorList });
    }
    /* eslint-disable-next-line */
  }, [frontColorList, activeFront]);

  useEffect(() => {
    if (wardrobesConfigs[activeWardrobe]) {
      let activeTypes = wardrobe.types;
      let frontsList = wardrobe.fronts;
      let activeDimensions = wardrobe.dimensions;
      if (!state.panelDefaultLoad) {
        activeTypes = Object.keys(activeTypes);
        activeTypes.shift(); // usuniecie typu korpus
        activeTypes.push(3); // 3 to wybarwienia
        let strict = !wardrobe.is_corner;
        props.getFrontsByType(activeTypes, activeDimensions, strict);
        setState({
          ...state,
          panelDefaultLoad: true,
        });
      }

      const wardrobeFronts = frontsList.filter(front => {
        return front && front.hasOwnProperty('safo');
      }).length;

      state.panelActive = wardrobeFronts === wardrobe.doors;

      if (!state.panelActive && wardrobe.defaultFronts !== undefined) {
        let defaultFronts = wardrobe.defaultFronts;
        let doorsSizes = [...wardrobe.doors_sizes];

        const frontColor = defaultFronts.colorName;
        const frontType = defaultFronts.type;

        doorsSizes.forEach((doorSize, idx) => {
          let front = {};
          if (['SZK', 'LUS', 'R'].indexOf(frontType) !== -1) {
            front = frontColorList.find(item => {
              return (
                item.safo.includes(frontType + '-' + frontColor) && item.dimensions.x === doorSize
              );
            });
          } else {
            front = frontColorList.find(item => {
              return (
                !item.safo.includes('SZK') &&
                !item.safo.includes('LUS') &&
                !item.safo.includes('R') &&
                item.safo.includes(frontColor) &&
                item.dimensions.x === doorSize
              );
            });
          }

          if (front !== undefined && front.hasOwnProperty('safo')) {
            wardrobe.fronts[idx] = front;
          }
        });
      }

      if (!state.panelActive && wardrobe.defaultFronts !== undefined) {
        let doorsSizes = [...wardrobe.doors_sizes];

        doorsSizes.forEach((doorSize, idx) => {
          if (wardrobe.fronts[idx] !== undefined && wardrobe.fronts.hasOwnProperty('safo')) {
            changeFrontMaterial(wardrobe.fronts[idx], idx);
          }
        });
      }

      wardrobesConfigs[activeWardrobe] = wardrobe;
      setWardrobesConfigs(wardrobesConfigs);

      setOpenDoorsState(false);
      setActiveFrontsPanels(['Front_0_0']);
    }
    setPrice();
    /* eslint-disable-next-line */
  }, [frontColorList, frontGroupList, activeWardrobe]);

  const skipAction = () => {
    wardrobesConfigs[activeWardrobe].withoutDoor = true;
    wardrobesConfigs[activeWardrobe].addons.brake = null;
    wardrobesConfigs[activeWardrobe].addons.track = null;

    history.push('/accessories-configuration');
  };

  return (
    <div>
      {wardrobesConfigs[activeWardrobe].is_corner ? null : (
        <div className="container__text container__text--position">
          <p>Wybierz skrzydło drzwi uchylnych w celu konfiguracji wybarwienia.</p>
          <div className="wardrobe-fronts__button" onClick={skipAction}>
            lub kup szafę bez drzwi
          </div>
        </div>
      )}
      <div className="container fronts-config">
        <div className="fronts-config__container">
          {state.colorList.length ? (
            <ColorListBox
              title={`Kolor drzwi: ${activeFrontTmp !== undefined ? activeFrontTmp.name : ''}`}
              changeMaterial={activeFront ? changeFrontMaterial : () => notify()}
              groupList={frontGroupList}
              colorsList={state.colorList}
              frontColor={activeFrontTmp !== undefined ? activeFrontTmp.slug : ''}
            />
          ) : (
            <Loader />
          )}
        </div>
        <SummaryBar
          btnText="przejdź dalej"
          btnIcon={true}
          btnLink="/wardrobe-handles-configuration"
          propClass={state.colorList.length ? 'active' : ''}
        />
      </div>
      <ToastContainer />
      <PopUp title="Informacje o drzwiach" popupName="colors-group">
        <ColorsGroupPopup colorGroups={frontGroupList} colorLists={state.colorList} />
      </PopUp>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    frontColorList: state.products.fronts,
    frontGroupList: state.products.frontsGroup,
    defaultFront: state.defaults.front,
    defaultHull: state.defaults.hull,
    handlesList: state.products.handlesColors,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getFrontsByType: (wardrobeType, activeDimensions, strict = true) =>
      dispatch(getFrontsByType(wardrobeType, activeDimensions, strict)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(HingedFrontsConfig);
